// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"4b386060","57":"eea1355c","153":"9c9fdce9","180":"d280499a","253":"c29bf279","284":"ad7b0e28","453":"893150da","757":"7bc71087","811":"f9ee8064","924":"57533a8a"}[chunkId] + ".chunk.js";
};